import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

import Grid from '@glass/web/components/base/Unstable_Grid2';
import { CENTER } from '@glass/web/modules/theme/constants';

import ExperienceButton from '@glass/shared/components/Section/ExperienceSection/ExperienceButton';
import { builderFirstStepParams } from '@glass/shared/modules/resumes/createBuilderFirstStepParams';

const ExperienceButtonContainer = React.memo(
  ({ itm, onClick, trackProps, persistQueryParams, shallow, prefetch }) => {
    const { text, params } = itm;
    const handleClick = useCallback(
      (evt) => {
        if (typeof onClick === 'function') {
          onClick(evt, itm);
        }
      },
      [itm, onClick],
    );

    return (
      <ExperienceButton
        params={params}
        persistQueryParams={persistQueryParams}
        prefetch={prefetch}
        shallow={shallow}
        trackProps={trackProps}
        onClick={handleClick}
      >
        {text}
      </ExperienceButton>
    );
  },
);

ExperienceButtonContainer.propTypes = {
  itm: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    params: PropTypes.object,
    text: PropTypes.string,
  }),
  onClick: PropTypes.func,
  persistQueryParams: PropTypes.bool,
  prefetch: PropTypes.bool,
  shallow: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  trackProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

function ExperienceButtons({ options, onClick, trackProps, persistQueryParams, shallow }) {
  const experienceOptions = useMemo(
    () =>
      options.map((option) => ({
        ...option,
        params: {
          ...builderFirstStepParams,
          ...(option.params || {}),
        },
      })),
    [options],
  );

  return (
    <Grid container justifyContent={CENTER} spacing={1}>
      {experienceOptions.map((itm, idx) => {
        return (
          <Grid key={itm.text} lg={2} md={3} sm={4} xs={6}>
            <ExperienceButtonContainer
              itm={itm}
              persistQueryParams={persistQueryParams}
              prefetch={idx === 0}
              shallow={shallow}
              trackProps={trackProps}
              onClick={onClick}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}

ExperienceButtons.propTypes = {
  onClick: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      params: PropTypes.object,
      text: PropTypes.string.isRequired,
    }),
  ),
  // eslint-disable-next-line react/forbid-prop-types
  persistQueryParams: PropTypes.bool,
  shallow: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  trackProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

ExperienceButtons.defaultProps = {
  persistQueryParams: false,
};

export default React.memo(ExperienceButtons);
